import {
  LISTA_AREAS_CONHECIMENTO_SUCESSO,
  GET_DISCIPLINAS_POR_AREA_SUCCESS
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  listaAreas: [],
  disciplinasPorArea: {} // { [areaId]: [disciplinas] }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_AREAS_CONHECIMENTO_SUCESSO:
      return { ...state, listaAreas: action.payload };
    case GET_DISCIPLINAS_POR_AREA_SUCCESS:
      return {
        ...state,
        disciplinasPorArea: {
          ...state.disciplinasPorArea,
          [action.payload.areaId]: action.payload.disciplinas
        }
      };
    default:
      return state;
  }
};
